import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const LeaveTypeService = {
  getLeaveTypes(obj) {
    return httpClient.post(endPoints.getLeaveTypes, obj);
  },
  deleteLeaveType(obj) {
    return httpClient.post(endPoints.deleteLeaveType, obj);
  },
  updateLeaveType(obj) {
    return httpClient.post(endPoints.updateLeaveType, obj);
  },
  addLeaveType(obj) {
    return httpClient.post(endPoints.addLeaveType, obj);
  }
};

export default LeaveTypeService;



// WEBPACK FOOTER //
// ./src/service/LeaveTypeService.js